// extracted by mini-css-extract-plugin
export default {"cell":"Cell_cell__5NTkY","element":"Cell_element__ip0Pk"};